import React, { useEffect } from 'react';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';
import Footer from '../cards/Footer';
import { getMarkDown, useDetectMobile } from '../utils';
import '../../../stylesheets/triagebot/Dialog.scss';

const ChangeDialog = ({ message,isDialogOpen, onClose, isAccepted, disabled , cdoName = ''}) => {

    const changeoverHeader = message?.data?.[0]?.changeoverHeader
        ? message.data[0].changeoverHeader
        : '';
    const changeoverText = message?.data?.[0]?.changeoverText
    ? message.data[0].changeoverText
    : '';

    const cancelButton = message?.data?.[0]?.cancelbutton
    ? message.data[0].cancelbutton
    : '';
    const continueButton = message?.data?.[0]?.continuebutton
    ? message.data[0].continuebutton
    : '';


    if (disabled) isDialogOpen = false;

    const {isMobile} = useDetectMobile();
    const isOpenCdo = cdoName.toLowerCase() === 'open';

    onClose = (typeof onClose === 'function')
        ? onClose
        : () => { }

    function getStyle(oElm, strCssRule) {
        var strValue = "";
        if (document.defaultView && document.defaultView.getComputedStyle) {
            strValue = document.defaultView.getComputedStyle(oElm, "").getPropertyValue(strCssRule);
        }
        else if (oElm.currentStyle) {
            strCssRule = strCssRule.replace(/-(\w)/g, function (strMatch, p1) {
                return p1.toUpperCase();
            });
            strValue = oElm.currentStyle[strCssRule];
        }
        return strValue;
    }

    useEffect(() => {
        setTimeout(() => {
            const cards = document.getElementsByClassName('turn');

            if (!cards.length) return;

            const cWidth = cards[cards.length - 1].offsetWidth;
            const dialog = document.querySelector('#change-dialog .MuiDialog-paper');

            if (!dialog) return;

            const padding = parseInt(getStyle(dialog, 'padding-left')) + parseInt(getStyle(dialog, 'padding-right'));

            dialog.style.width = (cWidth - padding) + 'px';
            dialog.style.minWidth = (cWidth - padding) + 'px';
        }, 1)
    })

    const handleDialogEntered = () => {
        // Focus heading directly to avoid duplicate title announcement from wrapper + heading.
        document.getElementById('dialog-title-heading')?.focus();
    }

    const handleButtonEffect = ()=>{ 
        isAccepted(false);

        //document.activeElement.blur();
        setTimeout(() => {
            document.activeElement.blur();
        }, 0);
    }

    const handleDialogKeyDown = (event) => {
        if (event.key !== 'Tab') return;

        const target = event.target;
        const titleEl = document.getElementById('dialog-title-heading');
        const cancelBtn = document.querySelector('#change-dialog .cancel-button');
        const continueBtn = document.querySelector('#change-dialog .continue-button');

        // Tab from Continue → wrap to heading
        if (target === continueBtn && !event.shiftKey) {
            event.preventDefault();
            titleEl?.focus();
            return;
        }

        // Shift+Tab from heading → Continue (last button)
        if (target === titleEl && event.shiftKey) {
            event.preventDefault();
            continueBtn?.focus();
            return;
        }

        // Shift+Tab from Cancel → heading
        if (target === cancelBtn && event.shiftKey) {
            event.preventDefault();
            titleEl?.focus();
            return;
        }
    }

    return (
        <Dialog
            id='change-dialog'
            open={isDialogOpen}
            onClose={onClose}
            onBackdropClick={onClose}
            onKeyDown={handleDialogKeyDown}
            aria-label='Change answer dialog'
            disableAutoFocus
            TransitionProps={{
                onEntered: handleDialogEntered
            }}
            PaperProps={{
                className: !isMobile ? 'open' : '',
                tabIndex: -1
            }}
        >
            <div id="dialog-title">
                <h2 id='dialog-title-heading' className='headerText' tabIndex='-1'>{getMarkDown(changeoverHeader)}</h2>
            </div>

            <DialogContent dividers id="dialog-body">
                {/* This will delete any following responses and restart you from this question. */}
                {getMarkDown(changeoverText)}
            </DialogContent>
            
            <DialogActions id="dialog-footer">
                <Footer>
                    <button
                        className={isMobile ? 'mobile cancel-button' : 'cancel-button'}
                        onClick={handleButtonEffect}
                    >
                        {cancelButton}
                    </button>
                    <button
                        className='continue-button'
                        onClick={()=>isAccepted(true)}
                    >
                        {continueButton}
                    </button>
                </Footer>
            </DialogActions>
        </Dialog>
    )
};

export default ChangeDialog;